import SlideFrame from "./_SlideFrame";
import { Zap, Cpu, Phone, Shield } from "lucide-react";

const pillars = [
  { icon: Zap, t: "Live in weeks, not months", d: "Fast onboarding on a modern API-driven core." },
  { icon: Cpu, t: "AI-enhanced throughout", d: "ML-scored payment prompts, smart routing, automated dispositioning." },
  { icon: Phone, t: "Integrated call center", d: "AI-assisted agents for borrower support, payments, and recoveries." },
  { icon: Shield, t: "Operator-led execution", d: "Real servicing experience running every line of your portfolio." },
];

export default function SlideBuiltModern() {
  return (
    <SlideFrame tag="03 · The Product">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
        <div>
          <p className="overline mb-6">Built for modern lending</p>
          <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-4xl">
            Flexibility, speed, and human judgment — <em className="italic text-primary">in one layer</em>.
          </h2>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-foreground/20 border border-foreground/20">
        {pillars.map(({ icon: Icon, t, d }, i) => (
          <div key={i} className="bg-background p-8 flex flex-col gap-4 min-h-[220px]">
            <Icon className="w-5 h-5 text-primary" strokeWidth={1.5} />
            <h3 className="font-display text-2xl leading-tight">{t}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mt-auto">{d}</p>
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
